import lockStatusJson from "../assets/datas/lock-status.json"
import {LOCK_INIT, LOCK_NO, LOCK_YES} from "@/constants/user";

export function getLockStatuses() {
    return lockStatusJson.result
}

export function getSettableLockStatuses() {
    return lockStatusJson.result.filter(function (item) {
        return item._id != LOCK_INIT
    })
}

//=====

export function getLockStatusName(id) {
    for (let i = 0; i < lockStatusJson.result.length; i++) {
        let obj = lockStatusJson.result[i]
        if (obj._id == id) {
            return obj.name
        }
    }
    return ""
}

export function getLockStatusDesc(id) {
    for (let i = 0; i < lockStatusJson.result.length; i++) {
        let obj = lockStatusJson.result[i]
        if (obj._id == id) {
            return obj.desc
        }
    }
    return ""
}
